import React from "react";
import {
    AppBar, Toolbar, Box, IconButton, Typography,
    Tooltip, Avatar, Badge
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationsIcon from "@mui/icons-material/Notifications";
import LogoutIcon from "@mui/icons-material/Logout";
import { useAuth } from "../../utils/AuthContext";
import packageJson from "../../../../package.json"; // Pfad ggf. anpassen!

export default function Header({ onOpenNav }) {
    const { logout } = useAuth();

    return (
        <AppBar position="fixed" color="inherit" sx={{ borderBottom: '1px solid rgba(2,14,41,.08)', backgroundColor: '#fff' }}>
            <Toolbar sx={{ minHeight: 72, display: 'flex', gap: 2 }}>
                <IconButton edge="start" onClick={onOpenNav} sx={{ display: { md: 'none' }, mr: 1 }}>
                    <MenuIcon />
                </IconButton>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box
                        component="img"
                        src={`${process.env.PUBLIC_URL}/images/favicon.png`}
                        alt="Logo"
                        sx={{ width: 36, height: 36, borderRadius: 2 }}
                    />
                    <Typography variant="h6" sx={{ fontWeight: 800, letterSpacing: '.2px' }}>
                        HRI Admin
                    </Typography>
                </Box>

                <Box sx={{ flexGrow: 1 }} />

                Software Version: {packageJson.version}

                <Tooltip title="Benachrichtigungen">
                    <IconButton>
                        <Badge color="primary" variant="dot" overlap="circular">
                            <NotificationsIcon />
                        </Badge>
                    </IconButton>
                </Tooltip>

                <Tooltip title="Account">
                    <Avatar sx={{ bgcolor: 'secondary.main', width: 36, height: 36 }}>FH</Avatar>
                </Tooltip>

                <Tooltip title="Abmelden">
                    <IconButton onClick={logout}>
                        <LogoutIcon />
                    </IconButton>
                </Tooltip>
            </Toolbar>
        </AppBar>
    );
}
